import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

export default class Extension extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            serialNo: this.props.serialNo,
            extensionNumber: this.props.extension.extensionNumber,
            name: this.props.extension.name,
            alias: this.props.extension.endpoint.alias,
            username: this.props.extension.endpoint.username,
            number: this.props.extension.number
        }
    }


    render() {
        const { name, extensionNumber, alias, username, number } = this.state
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Extension details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form className="form-wrapper">
                            <div className="form-group">
                                <label htmlFor="name"> Extension Name:</label>
                                <input type="text" className="form-control" name="name"
                                    id="name" value={name || ''} disabled />
                            </div>
                            <div className="form-group">
                                <label htmlFor="extensionNumber"> Extension Number:</label>
                                <input type="text" className="form-control" name="extensionNumber"
                                    id="extensionNumber" value={extensionNumber || ''} disabled />
                            </div>
                            <div className="form-group">
                                <label htmlFor="alias">SIP Alias:</label>
                                <input type="text" className="form-control" name="alias"
                                    id="alias" value={alias || ''} disabled />
                            </div>
                            <div className="form-group">
                                <label htmlFor="username"> SIP Username:</label>
                                <input type="text" className="form-control" name="username"
                                    id="username" value={username || ''} disabled />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Organization name:</label>
                                <input type="text" className="form-control" name="name"
                                    id="name" value={name || ''} disabled />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Number:</label>
                                <input type="text" className="form-control" name="number"
                                    id="number" value={number || ''} disabled />
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <button className="btn btn-purple" onClick={() => this.props.handleSubmitOrganization(this.state)}>
                            Save
                </button> */}
                        <button className="btn btn-lightblue" onClick={this.props.handleClose}>
                            Close
                </button>

                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
Extension.propTypes = {
    serialNo: PropTypes.string,
    extension: PropTypes.object,
    handleClose: PropTypes.func,
    show: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/extensionsComponent/modals/extension.js